<template>
  <div>
    <div class="works_item" style="width:2.68rem" v-for="(item, i) in list" :key="i">
      <div class="works_bg" @click="toOpusDetail(item)">
        <img :src="item.opusCover" alt="" v-if="item.opusCover!=='undefined'&&item.opusCover" />
        <img src="../../../assets/defaultCourseCover.png" alt="" v-else />
      </div>
      <div class="info">
        <h3>{{ item.opusName }}</h3>
        <Row class="tools">
          <Col span="8">
            <div class="look">
              <span>{{ item.viewNumber }}</span>
            </div>
          </Col>
          <Col span="8">
            <div :class="item.isPraised ? 'like' : 'disLike'">
              <span>{{ item.praiseNumber }}</span>
            </div>
          </Col>
        </Row>
        <div class="author">
          <Avatar :src="item.studentAvatar" size="32" style="margin-top: -.05rem" @click.native="toMyclassmate()"></Avatar>
          <span class="author_name">{{ item.studentName }}</span
          ><span v-if="item.className"> ({{ item.className }} )</span>
          <span v-else></span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getRequest } from '@/libs/axios'
export default {
  name: 'opusItem',
  data() {
    return {
      list: []
    }
  },
  props: {
    httpUrl: {
      type: String,
      default: null
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      const res = await getRequest(this.httpUrl)
      this.list = res.result
      console.log(res)
    },
    // 进入作品详情
    toOpusDetail(item) {
      // this.$router.push(`/opusDetail?id=${id}`)
      const { opusType, opusId, studentId, isActivityOpus = false } = item;
      if(opusType == 2){
        this.$router.push(`/opusDetail?id=${item.opusId}&isOpend=''&opusPath=''`)
      };
      if(opusType == 3){
        let routeUrl = this.$router.resolve({
          path: '../peixun/showPython',
          query: { opusId, studentId, isActivityOpus }
        })
        window.open(routeUrl.href, '_blank')
      };
    },
    // 点击头像进入我的同学
    toMyclassmate() {
      this.$router.push('/student/myClassmate')
    }
  }
}
</script>
<style scoped lang="less">
.works_item {
    float: left;
  overflow: hidden;
  width: 2.68rem;
  height: 100%;
  background-color: #fff;
  border-radius: 0.12rem;
      margin-right: 0.15rem;
  margin-bottom: 0.5rem;
  .works_bg {
    position: relative;
    width: 100%;
    height: 1.94rem;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .info {
    padding: 0 0.2rem 0.2rem;
    font-size: 0.14rem;
    color: #333;
    margin-top: 0.18rem;

    h3 {
      line-height: 0.18rem;
      font-weight: 400;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .author {
      height: 0.36rem;
      line-height: 0.36rem;
      font-size: 0.14rem;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      span {
        cursor: pointer;
        img {
          width: 0.32rem;
          height: 0.32rem;
          margin-top: -0.05rem;
        }
      }
      .author_name {
        margin-left: 0.14rem;
      }
    }
  }
}
.tools {
  position: relative;
  display: flex;
  align-items: center;
  height: 0.22rem;
  margin: 0.15rem 0;
  font-size: 0.14rem;
  cursor: pointer;
  span {
    margin-left: 0.14rem;
  }
  .refer{
    color: #76d18e;
  }
}
.look {
  width: 0.22rem;
  height: 0.13rem;
  line-height: 0.13rem;
  background: url(../../../assets/look.png) no-repeat center 1%;
  background-size: 100% 100%;
  span {
    margin-left: 0.3rem;
  }
}
// 点赞模块
.like {
  width: 0.15rem;
  height: 0.16rem;
  line-height: 0.16rem;
  background: url('../../../assets/good_l.png') no-repeat center -0.01rem;
  background-size: 100% auto;
  span {
    margin-left: 0.3rem;
  }
}
.disLike {
  width: 0.15rem;
  height: 0.16rem;
  line-height: 0.16rem;
  background: url('../../../assets/good.png') no-repeat center -0.01rem;
  background-size: 100% auto;
  span {
    margin-left: 0.3rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/teacher/components/opusItem.vue